import { PlanProfiles } from '../enums/plan-profiles';
import { BILLING_PLANS_GOODBETTERBEST_2025_Q2 } from '../enums/billing-plan-ids';

// this logic checks the plan profile to determine if the seller is on the new line-up profile
export const isNewLineUpPlanProfile = (planProfileId) => planProfileId >= PlanProfiles.goodbetterbest_2025_q2.id;

// this logic checks the profile and billing plan to determine if the seller is on the new line-up plan
export const isNewLineupPlanPorfileAndBillingPlan = (planProfileId, billingPlanId) => {
  const isGoodBetterBestProfile = planProfileId >= PlanProfiles.goodbetterbest_2025_q2.id;
  const isGoodBetterBestBillingPlan = BILLING_PLANS_GOODBETTERBEST_2025_Q2.includes(billingPlanId);
  return isGoodBetterBestProfile && isGoodBetterBestBillingPlan;
};
